"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextTitle = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const buttonAttrs = (onClick) => {
    if (!onClick)
        return null;
    return {
        onClick,
        onKeyDown: (event) => {
            switch (event.key) {
                case 'Enter':
                case ' ':
                    onClick(event);
                    break;
            }
        },
        tabIndex: 0,
        role: 'button',
    };
};
const blockClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.ui3,
    fz: '8.5px',
    d: 'block',
    pad: '0px 20px',
    mar: 0,
    textTransform: 'uppercase',
    lh: '2.1em',
    letterSpacing: '1px',
    ta: 'right',
    us: 'none',
});
const ContextTitle = ({ icon, children, onClick, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    if (icon) {
        children = (React.createElement("span", null,
            React.createElement("span", { style: {
                    display: 'inline-block',
                    transform: 'scale(.75)',
                    opacity: 0.8,
                    transformOrigin: '50% 100%',
                    verticalAlign: 'bottom',
                    marginTop: -8,
                } },
                icon,
                "\u00A0"),
            children));
    }
    return (React.createElement("h6", { ...rest, className: blockClass({ col: styles.g(0.4) }), ...buttonAttrs(onClick) }, children));
};
exports.ContextTitle = ContextTitle;
